import { cloneVNode, h } from 'vue';

import { classNames, isValidElement } from '@components/utils';

import { CdsLoader } from '../../CdsLoader';
import { CdsIcon } from '../../CdsIcon';
import { CdsFunctionalButton } from '../../CdsButton';

import type { TCdsIconsName } from '@central-design-system/icons';
import type { ITreeNodeProps } from '../composable';
import type { VNode } from 'vue';

export interface SwitcherIconProps extends ITreeNodeProps {
  expanded: boolean;
  loading: boolean;
}

export function renderSwitcherIcon(
  switcherIcon: any,
  showLine: boolean | { showLeafIcon: boolean | TCdsIconsName } | undefined,
  props: SwitcherIconProps
) {
  const { isLeaf, expanded, loading } = props;

  let icon: VNode = switcherIcon;

  if (loading) {
    return h(CdsLoader, { class: 'cds-tree__switcher-loading-icon', size: 'xs' });
  }

  let showLeafIcon: TCdsIconsName | boolean = false as unknown as TCdsIconsName;

  if (showLine && typeof showLine === 'object') {
    showLeafIcon = showLine.showLeafIcon;
  }

  let defaultIcon = null;

  const switcherCls = classNames('cds-tree__switcher-icon', { 'cds-tree__switcher-icon--expanded': expanded });

  if (isLeaf) {
    if (showLine) {
      if (typeof showLine === 'object' && showLeafIcon) {
        defaultIcon = h(CdsIcon, { name: typeof showLeafIcon === 'string' ? showLeafIcon : 'doc' });
      } else {
        defaultIcon = h('span', { class: 'cds-tree__switcher-leaf-line' });
      }
    }

    return defaultIcon;
  } else {
    defaultIcon = h(CdsFunctionalButton, { icon: 'chevron-down', class: switcherCls });

    if (showLine) {
      defaultIcon = h(CdsFunctionalButton, { icon: expanded ? 'minus' : 'plus', class: switcherCls });
    }
  }

  if (typeof switcherIcon === 'function') {
    icon = switcherIcon({ ...props, defaultIcon, switcherCls });
  } else if (isValidElement(icon)) {
    icon = cloneVNode(icon, { class: switcherCls });
  }

  return icon || defaultIcon;
}
